<template>
  <div>
    <loader v-if="loading"></loader>
    <div v-else>

      <b-form class="p-3 border-bottom clearfix" @submit="createNote">
        <b-form-group
                id="input-group-1"
                label="Note:"
                label-for="input-1"
        >
          <b-form-textarea
                  required
                  v-model="form.note"
                  id="textarea"
                  placeholder="Enter something..."
                  rows="3"
                  max-rows="6"
          ></b-form-textarea>
        </b-form-group>

        <div class="row">
          <div class="col-md-6">
            <b-form-checkbox
                    v-model="form.isImportant"
                    id="checkbox-1"
                    name="checkbox-1"
                    :value="true"
                    :unchecked-value="false"
            >Important</b-form-checkbox>
          </div>
          <div class="col-md-6">
            <b-button class="float-right" type="submit" variant="primary">Submit</b-button>
          </div>
        </div>


      </b-form>

      <div v-if="data">
        <div class="media p-3 border-bottom" v-for="note in data.data" :key="note.id">

          <b-modal :id="String(note.id)" title="Delete Note" @ok="() => deleteNote(note.id)">
            <p class="my-4">Confirmation</p>
          </b-modal>

          <div class="media-body">
            <div class="clearfix">
              <h5 class="mt-0 float-left">{{note.admin.name}} {{note.admin.surname}}</h5>
              <small v-if="note.isImportant" class="badge badge-pill badge-danger float-left ml-3 mt-1">Important</small>
              <b-icon icon="trash" class="float-right ml-2 mt-1" v-b-modal="String(note.id)"></b-icon>
              <time class="float-right"><small>{{note.createdAt | moment("dddd, MMMM Do YYYY, h:mm:ss a")}}</small></time>
            </div>
            <p class="pt-2 pb-2 mb-0">{{note.note}}</p>
          </div>
        </div>

        <div class="ml-auto mr-3 mt-3">
          <b-pagination
                  @change="setPage"
                  :disabled="loading"
                  align="right"
                  v-model="data.page"
                  :total-rows="data.total"
                  :per-page="perPage"
          ></b-pagination>
        </div>
      </div>
      <div class="text-center m-3" v-else>
        <h5 class="card-title">Search Result</h5>
        <p class="card-text">No Data</p>
      </div>

    </div>
  </div>
</template>

<script>
import GetUserNotes from '../../../../store/actions/getUserNotes';
import CreateNote from '../../../../store/actions/createNote';
import DeleteNote from '../../../../store/actions/deleteNote';
import ShowError from "../../../../helpers/showError";
import ContentLoader from '../../../../components/ContentLoader';

export default {
  name: 'UserNotes',
  components: {
    loader: ContentLoader,
  },
  data(){
    return {
      form: {
        note: '',
        isImportant: false
      },
      loading: false,
      data: false,
      perPage: 10,
      page: 1,
    }
  },
  created() {
    this.getNotes();
  },
  methods: {
    async createNote() {
      try {
        this.loading = true;
        await CreateNote({
          user: {id: this.$route.params.id},
          note: this.form.note,
          isImportant: this.form.isImportant
        });
        this.form = {
          note: '',
          isImportant: false,
        };
        this.getNotes();
      } catch (e) {
        ShowError(this, e);
      } finally {
        this.loading = false;
      }
    },
    setPage(page){
      this.page = page;
      this.getNotes();
    },
    async getNotes(){
      try {
        this.loading = true;
        this.data = await GetUserNotes(this.$route.params.id, {perPage: this.perPage, page: this.page});
      } catch (e) {
        ShowError(this, e);
      } finally {
        this.loading = false;
      }
    },
    async deleteNote(id) {
      try {
        this.loading = true;
        await DeleteNote(id);
        this.getNotes();
      } catch (e) {
        ShowError(this, e);
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>
